import React, { useEffect } from 'react'
import { Container, Table, Alert, Row, Col } from 'react-bootstrap'
import InventoryUnit from '../components/InventoryUnit'
import { listInventory } from '../actions/inventoryActions'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams, Routes, Route } from 'react-router-dom'
import SearchBox from '../components/SearchBox'
import Loader from '../components/Loader'
import Message from '../components/Message'
import Paginate from '../components/Paginate'

const Inventory = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { pageNumber } = useParams() || 1
  const { keyword } = useParams()

  const inventoryList = useSelector((state) => state.inventoryList)
  const { loading, error, inventory, page, pages, count } = inventoryList

  const inventoryAdd = useSelector((state) => state.inventoryAdd)
  const { success } = inventoryAdd

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const isAuthenticated = Boolean(ownerInfo || userInfo)

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(listInventory(pageNumber, keyword))
    } else {
      dispatch({ type: 'INVENTORY_LIST_RESET' })
      navigate('/login')
    }
  }, [dispatch, isAuthenticated, pageNumber, keyword, navigate])

  useEffect(() => {
    if (success) {
      navigate('/inventory')
    }
  }, [success, navigate])

  return (
    <Container>
      <Paginate pages={pages} page={page} />
      <Row className='align-items-center'>
        <Col>
          <h3 className='my-2'>Inventory List</h3>
        </Col>
      </Row>
      <Row className='my-2 align-items-center'>
        <Col>
          <Routes>
            <Route path='/*' element={<SearchBox />} />
          </Routes>
        </Col>
      </Row>

      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {/* {alert.show && showAlert(alert.message, alert.variant)} */}
      {count === 0 && <Message variant='info'>None Found</Message>}
      {/* {count === 0 && showAlert('None Found', 'info')} */}
      {loading ?
        <Loader />
      : error ?
        <Message variant='danger'>{error}</Message>
      : <Table striped bordered hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>UPC</th>
              <th>Item</th>
              <th>Manufacturer</th>
              <th>Name</th>
              <th>Qty</th>
              <th>Low</th>
              <th>Cost</th>
              <th>Price</th>
              <th>Last Update</th>
              <th>UPD</th>
              <th>DEL</th>
            </tr>
          </thead>
          <tbody>
            {inventory.map((unit) => (
              <InventoryUnit key={unit._id} unit={unit} />
            ))}
          </tbody>
        </Table>
      }
    </Container>
  )
}

export default Inventory
